import {Injectable} from "@angular/core";

/**
 * This service is used to request the tracking permission to the user.
 * Only available on iOS.
 */
export abstract class CookieBannerService {
    /**
     * Hides the cookie banner.
     */
    public abstract hide(): void;

    public abstract acceptAll(): void;

    public abstract acceptNecessary(): void;
}
@Injectable()
export class CookiebotCookieBannerService implements CookieBannerService {
    public hide() {
        // @ts-ignore
        const hasCookieBannerResponse =  window.Cookiebot.hasResponse as boolean;
        if (!hasCookieBannerResponse) {
            // Needed to hide the cookiebot banner
            // @ts-ignore
            window.Cookiebot.submitCustomConsent(false, false, false);
        }
        // @ts-ignore
        window.Cookiebot.hide();
    }

    public acceptAll() {
        // @ts-ignore
        window.Cookiebot.submitCustomConsent(true, true, true);
    }

    public acceptNecessary() {
        // @ts-ignore
        window.Cookiebot.submitCustomConsent(false, false, false);
    }


}
